import apiClient from './apiClient';

export interface WaitingLocation {
  id: number;
  name: string;
  name_kana?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  is_active?: boolean;
}

export type WaitingLocationInput = {
  name: string;
  name_kana?: string;
  address?: string;
  latitude?: number | null;
  longitude?: number | null;
};

const BASE = '/system/waiting-locations';

// 待機場所マスタ一覧を取得
export const getWaitingLocations = async (): Promise<WaitingLocation[]> => {
  const res = await apiClient.get(BASE);
  const data = res.data;
  if (data && Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : [];
};

// 待機場所を追加（座標未指定で住所があればバックエンドがNominatimで補完）
export const addWaitingLocation = async (input: WaitingLocationInput): Promise<WaitingLocation> => {
  const res = await apiClient.post(BASE, input);
  return res.data?.data ?? res.data;
};

// 待機場所を更新
export const updateWaitingLocation = async (id: number, input: Partial<WaitingLocationInput>): Promise<WaitingLocation> => {
  const res = await apiClient.put(`${BASE}/${id}`, input);
  return res.data?.data ?? res.data;
};

// 待機場所を削除（論理削除）
export const deleteWaitingLocation = async (id: number): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

const waitingLocationService = {
  getWaitingLocations,
  addWaitingLocation,
  updateWaitingLocation,
  deleteWaitingLocation,
};

export default waitingLocationService;
